import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=2006d310&scoped=true"
import script from "./canvas.vue?vue&type=script&lang=js"
export * from "./canvas.vue?vue&type=script&lang=js"
import style0 from "./canvas.vue?vue&type=style&index=0&id=2006d310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006d310",
  null
  
)

export default component.exports